import { useTranslation } from 'react-i18next';

export default function Hero() {
  const { t } = useTranslation();

  return (
    <section className="relative min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Elegant%20minimalist%20fashion%20flat%20lay%20photography%20overhead%20view%20of%20premium%20clothing%20shoes%20and%20accessories%20arranged%20artistically%20on%20clean%20light%20beige%20surface%2C%20soft%20natural%20window%20light%2C%20luxury%20editorial%20style%2C%20warm%20neutral%20earth%20tones%20cream%20beige%20white%2C%20high-end%20retail%20aesthetic%2C%20pristine%20composition&width=1600&height=900&seq=hero-bg&orientation=landscape"
          alt="AllChinaBuy products"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/50" />
      </div>

      <div className="relative z-10 w-full px-4 sm:px-6 lg:px-8 py-24 md:py-32">
        <div className="max-w-3xl mx-auto text-center">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-white leading-tight tracking-tight">
            {t('hero.title')}
          </h1>
          <p className="mt-6 text-lg md:text-xl text-white/90 leading-relaxed max-w-2xl mx-auto">
            {t('hero.subtitle')}
          </p>

          {/* Search Bar */}
          <div className="mt-8 max-w-xl mx-auto">
            <div className="flex items-center bg-white/95 backdrop-blur-sm rounded-full px-4 py-3 shadow-lg">
              <i className="ri-search-line text-foreground-400 text-lg flex-shrink-0" />
              <input
                type="text"
                placeholder={t('hero.search.placeholder')}
                className="flex-1 ml-3 bg-transparent text-sm text-foreground-800 placeholder:text-foreground-400 outline-none"
                readOnly
              />
            </div>
          </div>

          {/* CTAs */}
          <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-8 py-4 rounded-full bg-white text-foreground-900 font-semibold text-base hover:bg-white/90 transition-all shadow-lg whitespace-nowrap"
            >
              {t('hero.cta.explore')}
              <i className="ri-arrow-right-line" />
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-8 py-4 rounded-full bg-primary-500 text-white font-semibold text-base hover:bg-primary-600 transition-all shadow-lg whitespace-nowrap"
            >
              {t('hero.cta.mainSite')}
              <i className="ri-external-link-line" />
            </a>
          </div>

          {/* Secondary CTA */}
          <a
            href="/articles/allchinabuy-spreadsheet-complete-guide/"
            className="mt-4 inline-flex items-center gap-2 text-white/80 hover:text-white text-sm font-medium transition-colors"
          >
            {t('hero.cta.guides')}
            <i className="ri-arrow-right-line" />
          </a>
        </div>
      </div>
    </section>
  );
}